export default __webpack_public_path__ + "media/images/avatars/avatar7-9c9e38d7a6957e7c3f4b9ebe235b5f53.png";